import React, { useRef } from "react";
import PropTypes from "prop-types";

import Banners from "core/Banners";
import { NonMobileContent } from "./NonMobileContent";
import { MobileContent } from "./MobileContent";

import { StyledSiteHeader } from "./styles";
import LoadingSpinner from "core/LoadingSpinner";

const SiteHeader = ({
    currentUser,
    transparent,
    loginLink,
    joinLink,
    handleLogOut,
    heroSearchBgColor,
    isHeroSearchV2,
    loading,
    hideBanner,
    dismissBanner,
    bannerContent,
    bannerContentMobile,
    bannerKey
}) => {
    const siteHeaderRef = useRef(null);

    return (
        <>
            {!hideBanner && (
                <Banners
                    bannerDismiss={dismissBanner}
                    bannerKey={bannerKey}
                    bannerContent={bannerContent}
                    bannerContentMobile={bannerContentMobile}
                    type={"info"} // make sure to edit this to correct banner type
                />
            )}
            <StyledSiteHeader
                data-testid="site-header"
                transparent={transparent}
                heroSearchBgColor={heroSearchBgColor}
                isHeroSearchV2={isHeroSearchV2}
                ref={siteHeaderRef}
                id="site-header"
            >
                {!currentUser && loading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <NonMobileContent
                            siteHeaderRef={siteHeaderRef}
                            heroSearchBgColor={heroSearchBgColor}
                            isHeroSearchV2={isHeroSearchV2}
                            currentUser={currentUser}
                            transparent={transparent}
                            loginLink={loginLink}
                            joinLink={joinLink}
                            handleLogOut={handleLogOut}
                        />
                        <MobileContent
                            siteHeaderRef={siteHeaderRef}
                            heroSearchBgColor={heroSearchBgColor}
                            isHeroSearchV2={isHeroSearchV2}
                            currentUser={currentUser}
                            transparent={transparent}
                            loginLink={loginLink}
                            joinLink={joinLink}
                            handleLogOut={handleLogOut}
                        />
                    </>
                )}
            </StyledSiteHeader>
        </>
    );
};

SiteHeader.propTypes = {
    currentUser: PropTypes.object,
    transparent: PropTypes.bool,
    loginLink: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
        .isRequired,
    joinLink: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
        .isRequired,
    handleLogOut: PropTypes.func.isRequired,
    heroSearchBgColor: PropTypes.string,
    isHeroSearchV2: PropTypes.bool,
    loading: PropTypes.bool
};

export { SiteHeader };
